import { getApiUrl } from '~/utils';

export const API_URL = getApiUrl();

export const APP_ROOT = 'root';
